import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ItemLink from '../../components/item/ItemLink'
import moment from 'moment-timezone'
import ItemDetails from './ItemDetails'
import './simpleItem.pcss'

const SimpleItem = ({ item, dispatch, gaItemClickUiElement }) => {
  const itemTimestamp = item.get('timestamp')
  // @todo eslint-plugin-react-hooks doesn't know it but moment() is not pure
  const isToday = moment.unix(itemTimestamp).isAfter(moment().subtract(24, 'hours'))

  return (
    <div className='simple-item'>
      <h4 className='simple-item__title'>
        <ItemLink
          item={ item }
          dispatch={ dispatch }
          gaItemClickUiElement={ gaItemClickUiElement }
        />
      </h4>

      <div className='simple-item__meta'>
        <ItemDetails
          item={ item }
          isToday={ isToday }
        />
      </div>
    </div>
  )
}

SimpleItem.propTypes = exact({
  item: ImmutablePropTypes.map.isRequired,
  dispatch: PropTypes.func.isRequired,
  gaItemClickUiElement: PropTypes.string.isRequired,
})

export default SimpleItem
